module.exports = __webpack_public_path__ + "static/img/Seven of Cups.4f07c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Seven of Cups.jpg
// module id = 1295
// module chunks = 0